import { useGasv3Listener } from '@atlassian/post-office-context/analytics-listener/hook';
import { usePostOfficeUserInteractions } from '@atlassian/post-office-analytics/interactions';
import { useEffect } from 'react';

export const useClickedRovoNudgeDismiss = ({ nudgeId }: { nudgeId: string }): void => {
	const { onClosed } = usePostOfficeUserInteractions();

	const dismissed = useGasv3Listener({
		action: 'dismissed',
		actionSubject: 'rovoButton',
		actionSubjectId: 'aiRovoProactiveNudge',
		attributes: {
			recommendationFeatureId: nudgeId,
			dismissedMethod: 'manual',
		},
	});

	useEffect(() => {
		if (dismissed) {
			onClosed({ interactionIdentifier: 'dismiss' });
		}
	}, [dismissed, onClosed]);
};
